import { render, staticRenderFns } from "./Variety.vue?vue&type=template&id=0c337072&scoped=true&"
import script from "./Variety.vue?vue&type=script&lang=ts&"
export * from "./Variety.vue?vue&type=script&lang=ts&"
import style0 from "./Variety.vue?vue&type=style&index=0&id=0c337072&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c337072",
  null
  
)

export default component.exports